import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FaExclamationCircle } from "react-icons/fa";
import { getUser } from "../../helpers/AuthService";

import Loading from "../../components/Loading";
import MessageError from "../../components/MessageError";
import { verifyPaymentFlow } from "../../helpers/verifyPaymentFlow";

export default function Register() {
    const { holdId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const payment_intent = useMemo(
        () =>
            searchParams.get("payment_intent") ||
            searchParams.get("payment_intent_id") ||
            null,
        [searchParams]
    );

    const [error, setError] = useState(false);
    const [errorTitle, setErrorTitle] = useState(null);
    const [errorDescription, setErrorDescription] = useState(null);
    const [loadingText, setLoadingText] = useState("Estamos preparando tus boletos...");

    const showError = (title, message) => {
        setError(true);
        setErrorTitle(title);
        setErrorDescription(message);
    };

    useEffect(() => {
        const controller = new AbortController();

        const run = async () => {
            try {
                setError(false);
                setErrorTitle(null); setErrorDescription(null);

                const userLogged = await getUser();
                if (!userLogged) {
                    showError(
                        "Tu sesión expiró",
                        "Por favor inicia sesión nuevamente para continuar con tu compra."
                    );
                    return;
                }

                if (!holdId || !payment_intent) {
                    showError(
                        "No pudimos continuar con la compra",
                        "Parece que ocurrió un problema al regresar del pago. Puedes intentarlo nuevamente."
                    );
                    return;
                }

                await verifyPaymentFlow({
                    holdId,
                    paymentIntentId: payment_intent,
                    signal: controller.signal,
                    onStatus: ({ message }) => setLoadingText(message),
                    onCompleted: ({ transactionId }) => navigate(`/tickets/${transactionId}`),
                    onFailed: ({ title, message }) =>
                        showError(title || "No pudimos completar tu compra", message || "Intenta nuevamente."),
                });
            } catch (err) {
                console.error("Error verificando pago:", err);

                showError(
                    "No pudimos completar tu compra",
                    err?.response?.data?.message || "No pudimos confirmar tu compra en este momento. Intenta nuevamente o contacta a soporte."
                );
            }
        };

        run();

        return () => controller.abort();
    }, [holdId, payment_intent]);

    if (error) {
        return (
            <MessageError
                icon={FaExclamationCircle}
                title={errorTitle}
                description={errorDescription}
                action={
                    <div className="flex gap-3 flex-wrap justify-center mt-2">
                        <button onClick={() => navigate(`/payment/${holdId}`)} className="event-one__btn thm-btn px-6 py-2.5 text-sm">
                            Intentar nuevamente
                        </button>
                        <button onClick={() => navigate(`/`)} className="event-one__btn thm-btn px-6 py-2.5 text-sm">
                            Volver al inicio
                        </button>
                    </div>
                }
            />
        );
    }

    return <Loading text={loadingText} />;
}
